import React from "react";

import { PriorityCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function priority({ width, onResize }: Column.Options) {
	return base(ColumnId.Priority, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default priority;
